import { makeStyles } from '@material-ui/core/styles';
import { primaryButtonStyle, secondaryButtonStyle } from '../../shared/styles/buttons.styles';
import { redesignTheme } from '../../theme';

const { spacing, breakpoints, colors, sizes, fonts, fontSize, radius } = redesignTheme;

export const useHomePageHeroStyles = makeStyles(() => ({
  heroSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.md,
    padding: `${spacing.lg}px ${spacing.sm}px`,
    boxSizing: 'border-box',
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: spacing.lg,
      padding: '72px 80px',
    },
  },
  heroImageWrap: {
    position: 'relative',
    width: '100%',
    maxWidth: sizes.heroImageSize,
    aspectRatio: '1 / 1',
    borderRadius: 20,
    overflow: 'hidden',
    backgroundColor: colors.heroSurface,
    flexShrink: 0,
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      width: sizes.heroImageSize,
      height: sizes.heroImageSize,
    },
  },
  heroContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.md,
    width: '100%',
    maxWidth: sizes.contentMaxWidth,
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      maxWidth: 960,
    },
  },
  heroGreeting: {
    margin: 0,
    fontFamily: fonts.gothic,
    fontSize: fontSize.intro,
    color: colors.primary,
    lineHeight: 'normal',
  },
  heroGreetingRattached: {
    margin: 0,
    fontSize: fontSize.intro,
    fontFamily: fonts.opensans,
    color: colors.primary,
    lineHeight: 'normal',
  },
  heroGreetingName: {
    fontFamily: fonts.opensansSemiBold,
  },
  parcoursBar: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
    padding: spacing.sm,
    borderRadius: radius.sm,
    backgroundColor: colors.white,
    width: '100%',
    boxSizing: 'border-box',
    [`@media (min-width: ${breakpoints.mobile}px)`]: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 45,
    },
  },
  parcoursTitle: {
    margin: 0,
    fontFamily: fonts.opensansBold,
    fontSize: fontSize.base,
    color: colors.textBody,
  },
  pillButton: {
    ...primaryButtonStyle,
    borderRadius: 32,
    flexShrink: 0,
    transition: 'opacity 0.15s ease',
  },
  pillButtonIcon: {
    width: 16,
    height: 16,
  },
  heroStatsRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
    width: '100%',
    [`@media (min-width: ${breakpoints.mobile}px)`]: {
      flexDirection: 'row',
    },
  },
  heroStatCard: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    flex: 1,
    minWidth: 0,
    padding: 12,
    borderRadius: radius.sm,
    backgroundColor: colors.white,
    boxSizing: 'border-box',
  },
  heroTitle: {
    margin: 0,
    fontFamily: fonts.gothicSemiBold,
    fontSize: fontSize.xxl,
    color: colors.primaryDark,
    lineHeight: 'normal',
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      fontSize: fontSize.xl,
    },
  },
  heroDescription: {
    margin: 0,
    fontFamily: fonts.opensans,
    fontSize: fontSize.base,
    color: colors.primaryDark,
    lineHeight: 'normal',
  },
  heroTextBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
  },
  actionCards: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
    width: '100%',
  },
  actionCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
    padding: 12,
    borderRadius: radius.sm,
    backgroundColor: colors.white,
    boxSizing: 'border-box',
    [`@media (min-width: ${breakpoints.mobile}px)`]: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: spacing.md,
      minHeight: 72,
    },
  },
  actionCardContent: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    flex: 1,
    minWidth: 0,
  },
  actionCardButton: {
    [`@media (min-width: ${breakpoints.mobile}px)`]: {
      width: 232,
      boxSizing: 'border-box',
    },
  },
  primaryButton: {
    ...primaryButtonStyle,
    whiteSpace: 'nowrap',
    flexShrink: 0,
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      width: '100%',
    },
  },
  secondaryButton: {
    ...secondaryButtonStyle,
    whiteSpace: 'nowrap',
    flexShrink: 0,
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      width: '100%',
    },
  },
}));
